import { Box, Button, CloseButton, List, ListItem, Stack, Text, useDisclosure } from '@chakra-ui/react';
import React from 'react';
import { FcInfo } from 'react-icons/fc';
import { useRouteHelper } from '../../hooks/routesHelpers';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function OwnerAdvantegesBanner() {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { setRoute } = useRouteHelper();
  const history = useHistory();
  const { t } = useTranslation();

  const goToPublish = () => {
    const publishPage = setRoute('becomeAHost.propertyInformation');
    history.push(publishPage);
  };

  const closeBanner = () => {
    onClose();
  };

  const openBanner = () => {
    onOpen();
  };

  return isOpen ? (
    <Stack
      bg="white"
      borderRadius="8px"
      p="20px"
      pos="absolute"
      top={{ base: '250px', md: '33px', lg: '12px' }}
      left={{ base: '5%', md: '150px' }}
      border="1px solid #e2e8f0"
      boxShadow="rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;"
      onClick={closeBanner}
      w={{ base: '340px', md: '355px' }}
      h={{ base: '230px', md: '230px' }}
      fontSize={'15px'}
    >
      <CloseButton position="absolute" right={'5px'} top={'5px'} />
      <Text>
        {t('ownersBenefits.areYou')} <strong>{t('ownersBenefits.owner')}</strong> ?
      </Text>
      <Text>
        {' '}
        {t('ownersBenefits.postYourListing')} <strong>flate,</strong> {t('ownersBenefits.youWillHave')}
      </Text>
      <List>
        <ListItem>
          {' '}
          • {t('ownersBenefits.visibilityOn')} <strong>idealista.it </strong>
          {t('ownersBenefits.and')} <strong>casa.it </strong>
        </ListItem>
        <ListItem>
          {' '}
          • <strong> {t('ownersBenefits.securedPayments')}</strong>{' '}
        </ListItem>
        <ListItem>
          {' '}
          • {t('ownersBenefits.our')} <strong>{t('ownersBenefits.fullSupport')}</strong> {t('ownersBenefits.duringTheProcess')}
        </ListItem>
      </List>
      <Stack alignItems="center">
        <Button colorScheme={'secondary'} onClick={goToPublish} w="80%">
          {t('ownersBenefits.startNow')}
        </Button>
      </Stack>
    </Stack>
  ) : (
    <Box pos="absolute" right={{ base: '30px', md: '-19px' }} top={{ base: '-5px', md: '-8px' }} cursor="pointer">
      <FcInfo fontSize={'16px'} onClick={openBanner} />
    </Box>
  );
}
